import { IServerValidationError } from '@/Interfaces/ApiResponse/ApiValidationError.interface';
import { capitalize } from '@mui/material';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';

export const getFieldErrorProps = (fieldState: Record<string, any>) =>
  fieldState.error
    ? {
        error: true,
        helperText: fieldState.error.message,
      }
    : {};

type MessageFunction = (error: IServerValidationError) => string;

const defaultErrorMessage: MessageFunction = ({ message }) => message;
const uniqueErrorMessage: MessageFunction = ({ field }) => `${capitalize(field)} already in use`;

const MESSAGE_GETTER: Record<string, MessageFunction> = {
  unique: uniqueErrorMessage,
};

export function handleApiValidationErrors<T extends FieldValues>(
  errors: IServerValidationError[],
  setError: UseFormSetError<T>,
) {
  errors.forEach(error => {
    const message = (MESSAGE_GETTER[error.rule] ?? defaultErrorMessage)(error);
    setError(error.field as Path<T>, { message, type: 'manual' });
  });
}
